import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { WalletService } from "../../services/wallet.service";
import { Tabs } from "../tabs";

@Component({
    selector: "ngx-recent-transaction",
    templateUrl: "./recent-transaction.component.html",
    styleUrls: ["./recent-transaction.component.scss"],
})
export class RecentTransactionComponent implements OnInit {
    isWhiteListed = true;
    currentAddress;
    isConnected = false;
    transactions;
    tabs = Tabs;
    contributionRules: any;
    userContribAmount = 0;
    constructor(
        private _apiService: ApiService,
        private _walletService: WalletService
    ) {}

    ngOnInit(): void {
        this.getTransactions();
        if (this._walletService.metamaskInstalled !== false) {
            // this.checkWhiteListStatus();
            this.getTransactions();
            this.getContributionAmountPerUser();
            this.updateState();
        } else {
            // this.checkWhiteListStatus();
            this.getContributionAmountPerUser();
            this.updateState();
            this.getContributionData();
        }
    }
    updateState = async () => {
        setInterval(() => {
            this.getTransactions();
            this.getContributionAmountPerUser();
        }, 15000);
    };
    getContributionData() {
        this._apiService
            .getStageRules(1) // Currently 1, will recive from db
            .subscribe((res) => {
                this.contributionRules = res;
            });
    }
    getContributionAmountPerUser = async () => {
        this.userContribAmount = 0;
        this.currentAddress = await this._walletService.getAddress();
        let sum: any;
        let contributionAmount = this._apiService
        .getSumPerActiveStage(1).subscribe(async(res)=> {
            this.userContribAmount = res['totalAmount']
        })
    };
    async checkWhiteListStatus() {
        this.currentAddress = await this._walletService.getAddress();
        // this.currentAddress = "0xBc41be112E9d028FfA404e55f09EeDf80673736D";
        if (this.currentAddress !== undefined && this.isConnected == false) {
            this._apiService
                .getCurrentWhiteListStatus(
                    "?filters[address][$eq]=" + this.currentAddress
                )
                .subscribe((res) => {
                    let data = res["data"];
                    if (data[0]["attributes"].Tier == "Seed") {
                        this.isWhiteListed = true;
                    } else {
                        this.isWhiteListed = false;
                    }
                });
        } else {
            this.currentAddress =
                await this._walletService.getCryptoComAddress();
            if (
                this.currentAddress !== undefined &&
                this.isConnected == false
            ) {
                this.isConnected = true;
                this._apiService
                    .getCurrentWhiteListStatus(
                        "?filters[address][$eq]=" +
                            this.currentAddress[0].toLowerCase()
                    )
                    .subscribe((res) => {
                        let data = res["data"];
                        if (data[0]["attributes"].Tier == "Seed") {
                            this.isWhiteListed = true;
                        } else {
                            this.isWhiteListed = false;
                        }
                    });
            }
        }
    }
    async getTransactions() {
        let tx;
        this.currentAddress = await this._walletService.getAddress();
        this._apiService
            .getTransactionPerAddress(this.currentAddress)
            .subscribe((res) => {
                this.transactions = res;
                // return this.transactions;
            });
    }
}
